module.exports = __webpack_public_path__ + "media/images/lp/lp01-2bc9ba263637fd7ff71fab918b0f72b0.webp";